<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加收入项"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="incomeInfo" :rules="rules" >
      <FormItem prop="name">
        <Input v-model="incomeInfo.name" placeholder="请输入收入项名">
        </Input>
      </FormItem>
      <FormItem prop="payer">
        <Input v-model="incomeInfo.payer" placeholder="请输入支付方名称">
        </Input>
      </FormItem>
      <FormItem prop="total">
        <InputNumber v-model="incomeInfo.total" placeholder="请输入收款总额">
        </InputNumber>
      </FormItem>
      <FormItem prop="payType">
        <Select v-model="incomeInfo.payType" style="width:200px">
          <Option v-for="item in payType" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="occurrenceDatetime">
        <DatePicker v-model="incomeInfo.occurrenceDatetime" type="date" placeholder="请输入收款时间" style="width: 200px"></DatePicker>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'AddIncomeModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      totalRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '收款总额不能为空', trigger: 'blur' }
          ]
        }
      },
      payTypeRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '支付类型不能为空', trigger: 'blur' }
          ]
        }
      },
      occurrenceDatetimeRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '收款时间不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        payType:[
          {label:'银行转账',value:1},
          {label:'现金支付',value:2},
          {label:'网络支付',value:3},
          ],
        incomeInfo: {
          name:null,
          payer:null,
          total:0,
          payType:1,
          occurrenceDatetime:null
        }
      }
    },
    methods: {
      ...mapActions([
        'IncomeServ_AddObj'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '添加收入项',
          content: '<p>是否确认添加收入项</p>',
          onOk: () => {
            store.dispatch('IncomeServ_AddObj', {params: this.incomeInfo}).then(() => {
              this.$Message.success('添加收入项成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.incomeInfo.name = null
          this.incomeInfo.payer = null
          this.incomeInfo.total = 0
          this.incomeInfo.payType = 1
          this.incomeInfo.occurrenceDatetime = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          total: this.totalRules,
          payType: this.payTypeRules,
          occurrenceDatetime: this.occurrenceDatetimeRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
